import { useAutoAnimate } from "@formkit/auto-animate/react"
import React, { useContext, useEffect, useState } from "react"
import Tile from "../components/elements/Tile"
import FakeMemory from "../components/FakeMemory"
import FiveFourTile from "../components/FiveFourTile"
import Fruchtgummi from "../components/Fruchtgummi"
import MemoryGame from "../components/MemoryGame"
import SimpleCaptcha from "../components/SimpleCaptcha"
import Sogehts from "../components/Sogehts"
import { WEEKPLAN } from "../config"
import { Context } from "../store/store"
import { updateIframeHeight, updateIframeScrollTo } from "../helper"

const Memory: React.FC = () => {
	const { globalState, dispatch } = useContext(Context)

	const [isCaptchaSolved, setIsCaptchaSolved] = useState<boolean>(false)
	const [animationRef] = useAutoAnimate<HTMLDivElement>()

	function captchaCallback(captchaResponse: boolean | string) {
		if (typeof captchaResponse === "string" && captchaResponse.length > 0) {
			dispatch({
				type: "SET_ENTRY",
				key: "extID",
				value: captchaResponse,
			})
			setIsCaptchaSolved(true)
		} else {
			setIsCaptchaSolved(false)
		}
	}
	useEffect(() => {
		const win: any = window
		const doc: any = document

		updateIframeHeight()

		if (win.location.hash) {
			let scrollElem = doc.querySelector(win.location.hash)

			updateIframeScrollTo(win.pageYOffset + scrollElem.getBoundingClientRect().top - 200)
			win.scrollTo({
				top: win.pageYOffset + scrollElem.getBoundingClientRect().top - 200,
				left: 0,
				behavior: "smooth",
			})
		} else {
			updateIframeScrollTo(0)
		}

		// eslint-disable-next-line
	}, [])

	return (
		<div className="">
			<FiveFourTile />

			{/* Layout testing */}
			{/* <FiveFourTile debugDay={1} />
			<FiveFourTile debugDay={2} />
			<FiveFourTile debugDay={3} />
			<FiveFourTile debugDay={4} />
			<FiveFourTile debugDay={5} />
			<FiveFourTile debugDay={6} />
			<FiveFourTile debugDay={0} /> */}

			<div className="contentGradient">
				<div className="pt-6">
					<Sogehts />
				</div>

				<div className="container">
					<h2 className="h2">Jetzt mitspielen</h2>

					{!isCaptchaSolved && <SimpleCaptcha callback={captchaCallback} />}
					<div className="mb-14 md:mb-28" ref={animationRef}>
						{isCaptchaSolved ? <MemoryGame key={globalState.extID} /> : <FakeMemory />}
					</div>

					<div className="container" id="gewinne">
						<h2 className="h2">Die Gewinne</h2>
						<p className="font-Museo text-center leading-normal lg:text-[28px]">Im gesamten Aktionszeitraum verlosen wir:</p>
					</div>
					<div className="px-4 pt-6 lg:pt-12 ">
						{WEEKPLAN.map((day, index) => (
							<Tile key={"winn" + index} day={day} />
						))}
					</div>
				</div>
				<Fruchtgummi />
			</div>
		</div>
	)
}
export default Memory
